import { Amplify } from 'aws-amplify'

// This configuration should match the Angular frontend configuration
// In a real implementation, this would come from environment variables or a config file
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID || 'us-east-1_XXXXXXXXX',
      userPoolClientId:
        import.meta.env.VITE_USER_POOL_CLIENT_ID ||
        'xxxxxxxxxxxxxxxxxxxxxxxxxx',
      region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
      },
    },
  },
}

// Configure Amplify
Amplify.configure(amplifyConfig)

export default amplifyConfig
